import {
  Entity,
  FileEntity,
  Image,
  OrderActionTypes,
  orderStatusesArray,
  PDFReportInformation,
  PrintColorsConstant,
  StockItem,
  UserSchema,
} from 'src/app/core';
import { PaymentEntity } from '../payment';
import { PrintBlockItem } from '../shared';
import { City } from '../transformation';

export type OrderTypes = 'print' | 'thesis' | 'thesis-edit';

export interface OrderDto {
  blocks: PrintBlockItem[];
  copiesNumber: number;
  talcColorId?: number;
  moreDetails?: string;
  localHash?: number;
  addressId?: number;
  bindingId?: number;
  isMixed: boolean;
  pageCount: number;
  type: OrderTypes;
  fileIds: number[];
  imageIds?: number[];
  // price: string;
  id?: number;

  sharedLink?: SharedLink;
  referralLinkId?: number;

  color: PrintColorsConstant;
}

export interface ThesisOrderEditDto extends OrderDto {}

export interface Order extends Entity {
  blocks?: PrintBlockItem[];
  copiesNumber: number;
  moreDetails?: string;
  binding?: StockItem;
  pageCount: number;
  type: OrderTypes;
  files: FileEntity[];
  images: Image[];
  descriptor?: FileEntity;
  status: OrderStatuses;
  color?: PrintColorsConstant;
  user?: UserSchema;
  hash?: number;
  sharedLink?: SharedLink;
  price: string;
  talcColor?: TalcColor;
  address?: unknown;
  isMixed: boolean;
  referralLink?: SharedLink;
  payment?: PaymentEntity;
  selected?: boolean;
}

export interface SharedLink extends Entity {
  key: number;
  owner: UserSchema;
}

export type OrderStatuses = (typeof orderStatusesArray)[number];

export type OrderServiceBusEvent = OrderBusEvent<Order | OrderDto>;

export interface PrintOrderInterface extends OrderDto {}

export interface ThesisOrderInterface extends OrderDto {
  onCoverImage?: unknown;
  instructorSignature?: unknown;
}

export interface ThesisEditOrderInterface extends OrderDto {
  format: unknown;
}

export interface OrderPrintBlock {
  start: number;
  end: number;
}

export interface OrderSaveOptions {
  order: OrderDto;
  type: OrderTypes;
  local?: boolean;
}

export interface OrderUpdateOptionsMeta {
  order: OrderDto;
}

export type OrderUpdateOptions = Readonly<OrderUpdateOptionsMeta>;

export interface OrderRemoveOptions {
  key: number;
}
export interface OrderLoadOptions {
  justShoppingCart?: boolean;
}

export interface OrderStoreController {
  save(
    options: OrderSaveOptions
  ):
    | number
    | Promise<number>
    | OrderDto
    | Order
    | Promise<OrderDto>
    | Promise<Order>;
  load(
    options?: OrderLoadOptions
  ): OrderDto[] | Promise<OrderDto[]> | Promise<Order[]>;
  remove(options: OrderRemoveOptions): void | Promise<void> | Promise<boolean>;
  update(options: OrderUpdateOptions): boolean | Promise<boolean>;
}

export interface OrderBusEvent<T> {
  type: 'add' | 'remove' | 'update' | 'unknown';
  payload?: T;
}

export interface OrderStoreResult {
  ok?: boolean;
  order: Order;
  message?: string;
}

export interface DataChip {
  name: string;
  data: string | number;
  justData?: boolean;
}

export interface DatabaseIncomeFileBlock {
  start: number;
  end: number;
  stock: StockItem;
}

export interface ColorDict {
  c: string;
  hc: string;
  bw: string;
}

type ColorTypes = 'hc' | 'c' | 'bw';
type ColorSides = '1' | '2';

export type SelectorType = `${ColorTypes}`;

export const colorsPair: ColorDict = {
  c: 'تمام رنگی',
  hc: 'نیمه رنگی',
  bw: 'سیاه و سفید',
};

export interface OrderShareData {
  order: Order;
}

export type OrderActionType = (typeof OrderActionTypes)[number];
export interface OrderAction {
  id: number;
  type: OrderActionType;
}
export interface OrderActionEvent<T> {
  data: T;
  type?: OrderAction;
}

export interface OrderTarefePageOptions {
  onesided: ColorDict;
  twosided: ColorDict;
}

export interface OrderTarefeOptions {
  A4: OrderTarefePageOptions;
  A5: OrderTarefePageOptions;
  A3: OrderTarefePageOptions;
}

export interface TalcColor extends Entity {
  type?: string;
  name: string;
  colorCode: string;
  amount: number;
  orders?: Order[];
}

export interface UserDashboardReportInfo {
  totalProgress: number;
  totalDelivered: number;
  totalCalculation: number;
  orders?: Order[];
}

export interface PrintOrderRouteData {
  orders?: Order[];
  user?: UserSchema;
  editMode?: boolean;
  isLoggedIn?: boolean;
  talcColors?: TalcColor[];
  sharedFile?: PDFReportInformation;
  order?: Order;
  pointer?: string;
}

export interface OrderInfo {
  size: string;
  type: string;
  side: string;
  copies: number;
  copiesNumber?: number;
  binding: string;
  instance: Order;
  talcColor: string;
  totalPageNum: number;
  status: OrderStatuses;
  ranges: { [key: string]: string[] };

  color?: string;
  createdAt?: string;
  hash?: number;
  hop?: number;
  id?: number;
  isMixed?: boolean;
  moreDetails?: any;
  pageCount?: string;
  price?: string;
  updatedAt?: string;
}

export interface OrderUpdateDto {
  price?: number;
  color?: PrintColorsConstant;
  bindingId?: number;
  talcColorId?: number;
  moreDetails?: string;
  copiesNumber?: number;
  type?: OrderTypes;
  addressId?: number;
  referralLinkId?: number;
  fileIds?: number[];
  imageIds?: number[];
  blocks?: PrintBlockItem[];
  description?: string;
}

export interface DeliveryMethodDto {
  cities: City[];
  createdAt: string;
  desc: string;
  icon: string;
  id: number;
  minPurchaseForFreeShipping: any;
  name: string;
  updatedAt: string;
  valueAdded: string;
}
